import { DEFAULT_USER_DATA } from "@/constants/defaults"
import type { TLoginUserData } from "@/schemas/user.schema"
import { observable } from "@legendapp/state"

interface AppData {
  isTrialBannerHidden: boolean
  isSidebarMenuExpanded: boolean
  userData: TLoginUserData & { xAuth: string }
  _old_webphone: boolean
  webphoneSelectedContactID?: string
  webphoneExpanded: boolean
  webphonePoppedOut: boolean
  webphonePopup: {
    height: number
    width: number
  }
}

const initialState: AppData = {
  isSidebarMenuExpanded: false,
  isTrialBannerHidden: false,
  userData: {
    ...DEFAULT_USER_DATA,
    xAuth: "",
  },
  _old_webphone: false,
  webphoneExpanded: true,
  webphonePoppedOut: false,
  webphonePopup: {
    height: 600,
    width: 420,
  },
}

interface AppStore extends AppData {
  //   changeSidebarMenuState: (setExpanded: boolean) => void
  //   setUserData: (userData: TLoginUserData & { xAuth: string }) => void
  //   setWebphoneExpanded: (expanded: boolean) => void
  //   setWebphonePoppedOut: (poppedOut: boolean) => void
  //   setWebphonePopupSize: ({ width, height }: { width: number; height: number }) => void
  //   changeWebphonePopupOld: (old: boolean) => void
  //   changeSelectedContactID: (contactID?: string) => void
}

export const appStore$ = observable<AppStore>({
  ...initialState,
})
